import React from "react";
import styles from "./spacer.module.scss";

export const SpacerV = () => {
    return <div className={styles.spacerV} />;
};
